// Turn off ESLint so we can paste JSON
/* eslint prettier/prettier: "off" */

// Preference options in list format for ACF use:
// genre_adult_contemporary : Adult Contemporary
// genre_alternative_indie : Alternative / Indie
// genre_classical : Classical
// genre_country : Country
// genre_electronic : Electronic
// preference_family_entertainment : Family Entertainment
// preference_festivals : Festivals
// genre_folk_americana : Folk / Americana
// genre_hiphop_rap : Hip-Hop / Rap
// genre_jam : Jam
// genre_jazz_blues : Jazz & Blues
// genre_latin : Latin
// genre_metal : Metal
// genre_pop : Pop
// genre_rock : Rock
// genre_rnb_soul : R&B / Soul


const jsonSchema = {
  "type": "object",
  "required": [
    "email"
  ],
  "properties": {
    "email": {
      "format": "email",
      "type": "string",
      "title": "Email"
    },
    "first_name": {
      "type": "string",
      "title": "First Name"
    },
    "last_name": {
      "type": "string",
      "title": "Last Name"
    },
    "zip": {
      "type": "string",
      "title": "Zip / Postal Code"
    },
    "preferences": {
      "type": "array",
      "title": "Preferences",
      "description": "Let us know which types of events you are interested in. Check all that apply.",
      "items": {
        "type": "string",
        "anyOf": [
          {
            "type": "string",
            "title": "Adult Contemporary",
            "enum": [
              "genre_adult_contemporary"
            ]
          },
          {
            "type": "string",
            "title": "Alternative / Indie",
            "enum": [
              "genre_alternative_indie"
            ]
          },
          {
            "type": "string",
            "title": "Classical",
            "enum": [
              "genre_classical"
            ]
          },
          {
            "type": "string",
            "title": "Country",
            "enum": [
              "genre_country"
            ]
          },
          {
            "type": "string",
            "title": "Electronic",
            "enum": [
              "genre_electronic"
            ]
          },
          {
            "type": "string",
            "title": "Family Entertainment",
            "enum": [
              "preference_family_entertainment"
            ]
          },
          {
            "type": "string",
            "title": "Festivals",
            "enum": [
              "preference_festivals"
            ]
          },
          {
            "type": "string",
            "title": "Folk / Americana",
            "enum": [
              "genre_folk_americana"
            ]
          },
          {
            "type": "string",
            "title": "Hip-Hop / Rap",
            "enum": [
              "genre_hiphop_rap"
            ]
          },
          {
            "type": "string",
            "title": "Jam",
            "enum": [
              "genre_jam"
            ]
          },
          {
            "type": "string",
            "title": "Jazz & Blues",
            "enum": [
              "genre_jazz_blues"
            ]
          },
          {
            "type": "string",
            "title": "Latin",
            "enum": [
              "genre_latin"
            ]
          },
          {
            "type": "string",
            "title": "Metal",
            "enum": [
              "genre_metal"
            ]
          },
          {
            "type": "string",
            "title": "Pop",
            "enum": [
              "genre_pop"
            ]
          },
          {
            "type": "string",
            "title": "Rock",
            "enum": [
              "genre_rock"
            ]
          },
          {
            "type": "string",
            "title": "R&B / Soul",
            "enum": [
              "genre_rnb_soul"
            ]
          }
        ]
      },
      "uniqueItems": true
    },
    "list_cid_entertainment": {
      "type": "string",
      "title": "Send me emails about CID Entertainment events?",
      "enum": [
        "True",
        "False"
      ],
      "enumNames": [
        "Yes",
        "No"
      ]
    },
    "list_cid_presents": {
      "type": "string",
      "title": "Send me emails about CID Presents events?",
      "enum": [
        "True",
        "False"
      ],
      "enumNames": [
        "Yes",
        "No"
      ]
    },
    "list_cid_colorado": {
      "type": "string",
      "title": "Send me emails about CID Colorado events?",
      "enum": [
        "True",
        "False"
      ],
      "enumNames": [
        "Yes",
        "No"
      ]
    },
    "list_cid_vmt": {
      "type": "string",
      "title": "Send me emails about Valley Music Travel events?",
      "enum": [
        "True",
        "False"
      ],
      "enumNames": [
        "Yes",
        "No"
      ]
    },
    "list_cidp_cmp": {
      "type": "string",
      "title": "Send me emails about Luke Bryan's Crash My Playa?",
      "enum": [
        "True",
        "False"
      ],
      "enumNames": [
        "Yes",
        "No"
      ]
    },
    "list_cidp_prm": {
      "type": "string",
      "title": "Send me emails about Phish Riviera Maya?",
      "enum": [
        "True",
        "False"
      ],
      "enumNames": [
        "Yes",
        "No"
      ]
    },
    "list_cidp_its": {
      "type": "string",
      "title": "Send me emails about Dead & Company Playing In The Sand?",
      "enum": [
        "True",
        "False"
      ],
      "enumNames": [
        "Yes",
        "No"
      ]
    },
    "list_cidp_dt": {
      "type": "string",
      "title": "Send me emails about Dave Matthews and Tim Reynolds Riviera Maya?",
      "enum": [
        "True",
        "False"
      ],
      "enumNames": [
        "Yes",
        "No"
      ]
    },
    "list_cidp_bdv": {
      "type": "string",
      "title": "Send me emails about Bassnectar's Deja Voom festival?",
      "enum": [
        "True",
        "False"
      ],
      "enumNames": [
        "Yes",
        "No"
      ]
    },
    "list_cidp_sun": {
      "type": "string",
      "title": "Send me emails about ODESZA's Sundara festival?",
      "enum": [
        "True",
        "False"
      ],
      "enumNames": [
        "Yes",
        "No"
      ]
    },
    "list_cidp_mfm": {
      "type": "string",
      "title": "Send me emails about the My Favorite Murder podcast's weekend in Santa Barbara?",
      "enum": [
        "True",
        "False"
      ],
      "enumNames": [
        "Yes",
        "No"
      ]
    },
    "list_cidp_adm": {
      "type": "string",
      "title": "Send me emails about Mumford & Sons' Agora Del Mar festival?",
      "enum": [
        "True",
        "False"
      ],
      "enumNames": [
        "Yes",
        "No"
      ]
    },
    "list_cidp_obh": {
      "type": "string",
      "title": "Send me emails about My Morning Jacket's One Big Holiday festival?",
      "enum": [
        "True",
        "False"
      ],
      "enumNames": [
        "Yes",
        "No"
      ]
    },
    "list_cidp_hf": {
      "type": "string",
      "title": "Send me emails about Darius Rucker's Hootie Fest festival?",
      "enum": [
        "True",
        "False"
      ],
      "enumNames": [
        "Yes",
        "No"
      ]
    },
    "cid_business_unit": {
      "type": "string",
      "enum": ["True", "False"],
      "default": "True"
    },
    "pardot_extra_field": {
      "type": "string",
      "title": "Comments"
    }
  }
}

const uiSchema = {
  "ui:rootFieldId": "cid-signup-form",
  "ui:order": [
    "email",
    "first_name",
    "last_name",
    "zip",
    "preferences",
    "list_cid_entertainment",
    "list_cid_presents",
    "list_cid_colorado",
    "list_cid_vmt",
    "cid_business_unit",
    "pardot_extra_field",
    "*"
  ],
  "email": {
    "ui:autofocus": true,
    "ui:emptyValue": "",
    "classNames": "cid-signup-form-group"
  },
  "first_name": {
    "ui:emptyValue": "",
    "classNames": "cid-signup-form-group"
  },
  "last_name": {
    "ui:emptyValue": "",
    "classNames": "cid-signup-form-group"
  },
  "zip": {
    "ui:emptyValue": "",
    "classNames": "cid-signup-form-group"
  },
  "preferences": {
    "ui:widget": "checkboxes",
    "classNames": "cid-signup-form-group"
  },
  "list_cid_entertainment": {
    "classNames": "cid-signup-form-group",
    "ui:widget": "radio"
  },
  "list_cid_presents": {
    "classNames": "cid-signup-form-group",
    "ui:widget": "radio"
  },
  "list_cid_colorado": {
    "classNames": "cid-signup-form-group",
    "ui:widget": "radio"
  },
  "list_cid_vmt": {
    "classNames": "cid-signup-form-group",
    "ui:widget": "radio"
  },
  "list_cidp_cmp": {
    "classNames": "cid-signup-form-group",
    "ui:widget": "radio"
  },
  "list_cidp_dt": {
    "classNames": "cid-signup-form-group",
    "ui:widget": "radio"
  },
  "list_cidp_its": {
    "classNames": "cid-signup-form-group",
    "ui:widget": "radio"
  },
  "list_cidp_prm": {
    "classNames": "cid-signup-form-group",
    "ui:widget": "radio"
  },
  "list_cidp_bdv": {
    "classNames": "cid-signup-form-group",
    "ui:widget": "radio"
  },
  "list_cidp_sun": {
    "classNames": "cid-signup-form-group",
    "ui:widget": "radio"
  },
  "list_cidp_mfm": {
    "classNames": "cid-signup-form-group",
    "ui:widget": "radio"
  },
  "list_cidp_adm": {
    "classNames": "cid-signup-form-group",
    "ui:widget": "radio"
  },
  "list_cidp_obh": {
    "classNames": "cid-signup-form-group",
    "ui:widget": "radio"
  },
  "list_cidp_hf": {
    "classNames": "cid-signup-form-group",
    "ui:widget": "radio"
  },
  "cid_business_unit": {
    "ui:widget": "hidden"
  },
  "pardot_extra_field": {
    "classNames": "cid-signup-form-group cid-signup-form-verification",
    "ariaHidden": true
  }
}

function prepFormData(formData, options) {
  let preppedFormData = { ...formData }
  const {
    hidePreferences
  } = options
  if (formData.preferences) {
    preppedFormData = jsonSchema.properties.preferences.items.anyOf.reduce(
      (formData, preferenceDef) => {
        const fieldName = preferenceDef.enum[0]
        formData[fieldName] =
          formData.preferences.indexOf(fieldName) !== -1 ? 'TRUE' : 'FALSE'
        // If we don't allow a person to select preferences in this form, then
        // don't opt them out of the ones that weren't selected.
        if (hidePreferences && formData[fieldName] === 'FALSE') {
          delete formData[fieldName]
        }
        return formData
      },
      preppedFormData,
    )
    delete preppedFormData.preferences
  }
  return preppedFormData
}

export { jsonSchema, uiSchema, prepFormData }
export default { jsonSchema, uiSchema, prepFormData }
